import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";

import { environment } from "../../../environments/environment";
import { GenericResponseDto } from "../models/generic-response.dto";
import { payloadHeader } from "./shared.service";
import { UserSupportMap } from "../models/profile/userSupport";
import { DeleteUserSupport } from "../models/profile/deleteUserSupport";
import { Employee } from "../models/profile/employee";

@Injectable({
  providedIn: "root",
})
export class UserSupportMapService {
  private userSupportManagementBaseURL = environment.baseUrl + "/UserSupport";
  constructor(private _http: HttpClient) {}

  getWhoSupportMeTableRecord(
    email: string
  ): Observable<GenericResponseDto<UserSupportMap[]>> {
    return this._http.get<GenericResponseDto<UserSupportMap[]>>(
      this.userSupportManagementBaseURL + "/WhoSupportMe?email=" + email
    );
  }

  getWhoISupportTableRecord(
    email: string
  ): Observable<GenericResponseDto<UserSupportMap[]>> {
    return this._http.get<GenericResponseDto<UserSupportMap[]>>(
      this.userSupportManagementBaseURL + "/WhoISupport?email=" + email
    );
  }

  updateWhoSupportMeAndI(
    payload: UserSupportMap
  ): Observable<GenericResponseDto<UserSupportMap>> {
    return this._http.put<GenericResponseDto<UserSupportMap>>(
      this.userSupportManagementBaseURL + "/UpdateUserSupport",
      payload
    );
  }

  deleteUserSupportMap(
    payload: DeleteUserSupport
  ): Observable<GenericResponseDto<UserSupportMap>> {
    return this._http.delete<GenericResponseDto<UserSupportMap>>(
      this.userSupportManagementBaseURL + "/DeleteUsersSupportMap",
      payloadHeader<DeleteUserSupport>(payload)
    );
  }

  getWhoSupportMeWithPersonalNumber(
    email: string
  ): Observable<GenericResponseDto<Employee[]>> {
    return this._http.get<GenericResponseDto<Employee[]>>(
      this.userSupportManagementBaseURL +
        "/WhoSupportMeWithPersonalNumber?email=" +
        email
    );
  }

  whoSupportMeWithPersonalNumberDashboardPoc(
    email: string
  ): Observable<GenericResponseDto<Employee[]>> {
    return this._http.get<GenericResponseDto<Employee[]>>(
      this.userSupportManagementBaseURL +
        "/WhoSupportMeWithPersonalNumberDashboardPoc?email=" +
        email
    );
  }
}
